// extracted by mini-css-extract-plugin
export var brandText = "roiForm-module--brandText--2209e";
export var button = "roiForm-module--button--c61b1";
export var emailAndWebContainer = "roiForm-module--emailAndWebContainer--83ec6";
export var formContainer = "roiForm-module--formContainer--81516";
export var formContainerLower = "roiForm-module--formContainerLower--1f837";
export var formContainerUpper = "roiForm-module--formContainerUpper--c44e5";
export var input = "roiForm-module--input--da1e6";
export var inputPrefix = "roiForm-module--inputPrefix--74397";
export var lowerRequiredText = "roiForm-module--lowerRequiredText--7d25b";
export var orderError = "roiForm-module--orderError--46cc5";
export var orderFieldGroup = "roiForm-module--orderFieldGroup--4c1ca";
export var orderLabel = "roiForm-module--orderLabel--f3b35";
export var orderValueContainer = "roiForm-module--orderValueContainer--32acc";
export var orderValueInput = "roiForm-module--orderValueInput--059cd";
export var requiredext = "roiForm-module--requiredext--710db";
export var smsToggle = "roiForm-module--smsToggle--0baa7";
export var textError = "roiForm-module--textError--00bb6";
export var textLabel = "roiForm-module--textLabel--d9a2d";
export var toggleContainer = "roiForm-module--toggleContainer--1439a";
export var toggleLabel = "roiForm-module--toggleLabel--77d63";
export var upperRequiredText = "roiForm-module--upperRequiredText--026c8";